export enum COOKIE_VALUES {
  BIK_VISITOR = 'bikvisitor',
  STORY_VIEWED = 'storeviewed',
  COLLECTION_VIEWED = 'collectionviewed',
}

export enum EVENT_NAME {
  WIDGET_VISITED = 'WIDGET_VISITED',
  COLLECTION_VIEWED = 'COLLECTION_VIEWED',
  STORY_VIEWED = 'STORY_VIEWED',
}
